// import React, { useEffect, useState } from "react";
// import moment from "moment";
// import { Spin } from "antd";
// import { getHolidayEnquiryList } from "../services/auth/authServices";

// // import { getHolidayEnquiryDetailById } from "../services/auth/authServices";

// const HolidayBookingDetail = ({ enquiryId }) => {

//     const [data, setData] = useState(null);

//     const [loading, setLoading] = useState(false);

//     console.log("enquiryId", enquiryId)

//     const fetchDetail = async () => {
//         setLoading(true);
//         try {
//             // const res = await getHolidayEnquiryList(enquiryId);
//             const res = await getHolidayEnquiryList();
//             const filteredData = res.data.find(
//                 (item) => item.id === enquiryId
//             );
//             setData(filteredData);
//         }

//         catch (err) {
//             console.log(err);
//         }
//         finally {
//             setLoading(false);
//         }

//     };


//     useEffect(() => {

//         if (enquiryId)

//             fetchDetail();

//     }, [enquiryId]);


//     if (loading)

//         return <Spin />

//     console.log("data", data)

//     return (

//         <div>

//             <h2>Holiday Enquiry Detail</h2>

//             <hr />


//             <p><b>Name:</b> {data?.name}</p>

//             <p><b>Email:</b> {data?.email}</p>

//             <p><b>Mobile:</b> {data?.mobile_number}</p>

//             <p><b>Type:</b> {data?.enquiry_type}</p>

//             <p><b>Message:</b> {data?.message_content}</p>

//             <p><b>Status:</b> {data?.followup_status}</p>

//             <p>

//                 <b>Date:</b>

//                 {moment(data?.created_at).format("DD MMM YYYY")}

//             </p>


//         </div>

//     );

// };

// export default HolidayBookingDetail;

import React, { useEffect, useState } from "react";
import moment from "moment";
import { Spin, Card, Descriptions, Tag, Timeline, Avatar, Empty } from "antd";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    MessageOutlined,
    CalendarOutlined,
    TagOutlined,
    ClockCircleOutlined,
    HistoryOutlined
} from "@ant-design/icons";
import { getHolidayEnquiryList } from "../services/auth/authServices";

const HolidayBookingDetail = ({ enquiryId }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchDetail = async () => {
        setLoading(true);
        try {
            const res = await getHolidayEnquiryList();
            const filteredData = res.data.find((item) => item.id === enquiryId);
            setData(filteredData);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (enquiryId) fetchDetail();
    }, [enquiryId]);

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'pending':
                return 'orange';
            case 'completed':
                return 'green';
            case 'in-progress':
                return 'blue';
            case 'cancelled':
                return 'red';
            default:
                return 'default';
        }
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" tip="Loading enquiry details..." />
            </div>
        );
    }

    if (!data) {
        return (
            <Empty
                description="No enquiry details found"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
        );
    }

    return (
        <div style={{ padding: '24px' }}>
            {/* Header Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '24px',
                borderBottom: '2px solid #f0f0f0',
                paddingBottom: '16px'
            }}>
                <h2 style={{ margin: 0 }}>
                    <HistoryOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                    Holiday Enquiry Details
                </h2>
                <Tag color={getStatusColor(data?.followup_status)} style={{ padding: '4px 12px' }}>
                    {data?.followup_status || 'PENDING'}
                </Tag>
            </div>

            {/* Main Details Card */}
            <Card
                style={{
                    marginBottom: '24px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                <Descriptions
                    bordered
                    column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
                    labelStyle={{ fontWeight: 600, backgroundColor: '#fafafa' }}
                >
                    <Descriptions.Item label={<><UserOutlined /> Name</>}>
                        {data?.name || 'N/A'}
                    </Descriptions.Item>

                    <Descriptions.Item label={<><MailOutlined /> Email</>}>
                        {data?.email || 'N/A'}
                    </Descriptions.Item>

                    <Descriptions.Item label={<><PhoneOutlined /> Mobile</>}>
                        {data?.mobile_number || 'N/A'}
                    </Descriptions.Item>

                    <Descriptions.Item label={<><TagOutlined /> Enquiry Type</>}>
                        <Tag color="blue">{data?.enquiry_type || 'GENERAL'}</Tag>
                    </Descriptions.Item>

                    <Descriptions.Item label={<><CalendarOutlined /> Created Date</>} span={2}>
                        {moment(data?.created_at).format('DD MMM YYYY, hh:mm A')}
                    </Descriptions.Item>

                    <Descriptions.Item label={<><MessageOutlined /> Message</>} span={2}>
                        <div style={{
                            backgroundColor: '#f5f5f5',
                            padding: '12px',
                            borderRadius: '4px',
                            minHeight: '80px'
                        }}>
                            {data?.message_content || 'No message provided'}
                        </div>
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            {/* Additional Information Card */}
            {data?.package && (
                <Card
                    title={
                        <span>
                            <ClockCircleOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                            Additional Information
                        </span>
                    }
                    style={{
                        marginBottom: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                    }}
                >
                    <Descriptions column={2} bordered>
                        <Descriptions.Item label="Package">
                            {data?.package?.package_name || 'Not specified'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Number of Adults">
                            {data?.no_of_adult || 'Not specified'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Number of Children">
                            {data?.no_of_children || 'Not specified'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Date of Travel">
                            {data?.date_of_travel ? moment(data?.date_of_travel).format('DD MMM YYYY') : 'Not specified'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Location">
                            {[data?.city, data?.state, data?.country].filter(Boolean).join(', ') || 'Not specified'}
                        </Descriptions.Item>

                        <Descriptions.Item label="Assigned By">
                            {data?.assign_by || 'System'}
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            )}


            {/* Follow-up Timeline Card */}
            <Card
                title={
                    <span>
                        <HistoryOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
                        Follow-up History
                    </span>
                }
                style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
            >
                {data?.followups && data?.followups?.length > 0 ? (
                    <Timeline
                        mode="left"
                        items={data?.followups.map((followup, index) => ({
                            dot: <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />,
                            children: (
                                <div style={{ marginBottom: '16px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <strong>{followup?.remarks || 'No remarks'}</strong>
                                        <Tag color={getStatusColor(followup?.status)}>{followup?.status || 'PENDING'}</Tag>
                                    </div>
                                    <div style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>
                                        <div>Followed by: {followup?.followed_by || 'System'}</div>
                                        <div>Created: {moment(followup?.created_at).format('DD MMM YYYY, hh:mm A')}</div>
                                        {followup.next_followup_date && (
                                            <div>
                                                <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                                Next Follow-up: {moment(followup?.next_followup_date).format('DD MMM YYYY')}
                                            </div>
                                        )}
                                        {followup.service && <div>Service: {followup?.service}</div>}
                                    </div>
                                </div>
                            ),
                        }))}
                    />
                ) : (
                    <Empty
                        description="No follow-up history available"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                )}
            </Card>

            {/* Footer with timestamps */}
            <div style={{
                marginTop: '24px',
                textAlign: 'right',
                color: '#999',
                fontSize: '12px',
                borderTop: '1px solid #f0f0f0',
                paddingTop: '16px'
            }}>
                <div>Created: {moment(data?.created_at).format('DD MMM YYYY, hh:mm A')}</div>
                <div>Last Updated: {moment(data?.updated_at).format('DD MMM YYYY, hh:mm A')}</div>
            </div>
        </div>
    );
};

export default HolidayBookingDetail;